module.exports = __webpack_public_path__ + "static/img/92070B_2_C_20210209_LC.5ad4ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_2_C_20210209_LC.png
// module id = f9tt
// module chunks = 0